import {ActionHandlerBase} from "../action-handler-base";
import {
    AppIdentifiers,
    ControlCenterDeeplink,
    ControlCenterOpenSource,
    IOpenControlCenterFullActionPayload
} from "@sparkware/uc-sdk-core";

export class OpenControlCenterFullActionHandler extends ActionHandlerBase<IOpenControlCenterFullActionPayload> {
    async handle(payload: IOpenControlCenterFullActionPayload): Promise<void> {
        if(!await this.services.user.ensureUserIsLoggedIn('OpenControlCenterFullActionHandler')) {
            throw new Error('User canceled the login');
        }

        this.services.userMenu.closeMenu();

        await this.services.messageBroker.channels.navigation.topics.openApp.publish({
            publisher: payload.launchInfo.sourceAppID.toString()
        }, {
            appID: AppIdentifiers.ControlCenterFull,
            launchInfo: {
                ...payload.launchInfo,
                appSpecificParameters: {
                    source: ControlCenterOpenSource.Lobby,
                    deeplink: ControlCenterDeeplink.Main,
                    ...payload.launchInfo?.appSpecificParameters
                }
            },
            correlationID: payload.correlationID
        });
    }
}
